import { installationFeePaymentOptions } from '../../../utils/constant';

export const disableOptions = (options, targets, value) => {
  const updatedOptions = [...options];
  targets.forEach(target => {
    updatedOptions.forEach(option => {
      if (option.fields.value === target) {
        // eslint-disable-next-line no-param-reassign
        option.fields.disabledOption = value;
      }
    });
  });
  return updatedOptions;
};

export const getConsolidationTotals = stateData => {
  const totals = {
    monthly: 0,
    oneTime: 0,
    threeYearEasyPayment: 0,
    fiveYearEasyPayment: 0
  };

  if (stateData.data && stateData.data.length > 0) {
    totals.monthly = stateData.monthlyCharges;
    totals.oneTime = stateData.oneTimeCharges;
  }

  return totals;
};

export const getConsolidationSelectionTotals = (stateData, name) => {
  const totals = {
    monthly: 0,
    oneTime: 0,
    threeYearEasyPayment: 0,
    fiveYearEasyPayment: 0
  };
  const selectionsList = {};

  if (stateData.data && stateData.data.length > 0) {
    totals.monthly = stateData.monthlyCharges;
    totals.oneTime = stateData.oneTimeCharges;
  }

  selectionsList[name] = totals;
  return selectionsList;
};

const LOCALE_FIELDS = {
  'en-US': { primary: 'offerDetailsEn', alt: 'offerDetailsFr' },
  'fr-CA': { primary: 'offerDetailsFr', alt: 'offerDetailsEn' }
};

export const getOfferDescription = (item, locale, isAlternative) => {
  if (!item) return '';

  const fields = LOCALE_FIELDS[locale];
  if (!fields) return '';

  const key = isAlternative ? fields.alt : fields.primary;
  return item[key] || '';
};

export const getInstallationFeePaymentType = installationFeePaymentOption => {
  if (
    [
      installationFeePaymentOptions.oneTime,
      installationFeePaymentOptions.oneTimeFR
    ].includes(installationFeePaymentOption)
  ) {
    return 'oneTime';
  }
  if (
    [
      installationFeePaymentOptions.threeYear,
      installationFeePaymentOptions.threeYearFR
    ].includes(installationFeePaymentOption)
  ) {
    return 'threeYearEasyPayment';
  }
  return null;
};
